import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { ClerkProvider } from "@clerk/clerk-react";
// import "./style/custom-antd.css";
import './App.css';
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { ConfigProvider } from 'antd';
import { ResizeProvider } from "./components/ResizeContext";
import 'antd/dist/reset.css'; 

const clerkPublishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (process.env.NODE_ENV === "production") {
  const clarityScript = document.createElement("script");
  clarityScript.type = "text/javascript";
  clarityScript.async = true;
  clarityScript.innerHTML = `
    (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "skw2l7qg30");
  `;
  document.head.appendChild(clarityScript);
}


if (process.env.NODE_ENV !== "development") {
  Sentry.init({
    dsn: "https://bb57634ad6554058b993ccacede7818f@o518363.ingest.sentry.io/5627150",
    integrations: [new Integrations.BrowserTracing()],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  });
}

ReactDOM.render(
  <ClerkProvider
    publishableKey={clerkPublishableKey}
    appearance={{
      elements: {
        footerAction: { display: "none" },
      },
    }}
  >
    <ConfigProvider>
      <ResizeProvider>
        <App />
      </ResizeProvider>
    </ConfigProvider>
  </ClerkProvider>,
  document.getElementById("root")
);
